const data = [
    {
        title:"BAJAJ",
        subTitle:"CT 100",
        daily:"₹199/Daily(24 hrs)",
        weekly:"₹849/Weekly(Mon-Fri)",
        monthly:"₹4699/Monthly(30 days)",
        info:"The CT 100 is Bajaj’s entry-level commuter motorcycle that is available in three variants. It is targeted at rural customers, who are looking for a hassle-free low-maintenance motorcycle with high fuel efficiency.The CT100 is based on the same single-cradle frame as the Platina and is powered by the same 99.3cc single-cylinder engine that also does duty in the Platina. This engine is a BS6-compliant, fuel-injected unit which produces 7.7bhp and 8.34Nm of torque and comes mated to a four-speed gearbox. This engine has been developed with a focus on extracting maximum efficiency, and Bajaj has claimed an average of 89.5kmpl for this motorcycle.",
        specification:[
            "Engine Capacity:99.27 cc",
            "Mileage:70 kmpl",
            "Kerb Weight:109 kg",
            "Fuel Tank Capacity:10.5 litres",
            "Seat Height:678 mm"
        ],
        img:[
            "https://assetscdn1.paytm.com/images/catalog/product/S/SC/SCOBAJAJ-CT-100RAGH918237768BBA75/1585912393498_0.jpg",
            "https://stat.overdrive.in/wp-content/odgallery/2016/02/28511_bajajCT100.jpg",
            "https://static.autox.com/uploads/2020/10/2020-bajaj-ct-100-updated-launched-m.jpg",
            "https://qph.fs.quoracdn.net/main-qimg-53024721428c27b91853f3be9a8871cb-c",
            "https://i.pinimg.com/originals/2a/5f/07/2a5f0736bf7b40c2576836125a270147.jpg"
        ]
    },
    {
        title:"HONDA",
        subTitle:"NAVI",
        daily:"₹229/Daily(24 hrs)",
        weekly:"₹949/Weekly(Mon-Fri)",
        monthly:"₹4249/Monthly(30 days)",
        info:"While the Navi might look like a motorcycle, it isn’t one. It is powered by Honda’s tried and trusted 110cc engine that powers the popular Activa. This engine capable of producing produces 8bhp of power and 9Nm of torque. The Navi features telescopic forks up front and a monoshock at the rear. Braking is taken care by drum brakes at both ends and is equipped with a combi-brake system which partially applies the front brake on the application of the rear brake. This reduces the overall braking distance thus improving braking efficiency.",
        specification:[
            "Engine Capacity:109.19 cc",
            "Mileage:45 kmpl",
            "Kerb Weight:99 kg",
            "Fuel Tank Capacity:3.5 litres",
            "Seat Height:765 mm"
        ],
        img:[
            "https://th.bing.com/th/id/R.e31e1a72abcb8548411846bc69d8fd86?rik=ASPOdX5A72uSVA&riu=http%3a%2f%2fstat.overdrive.in%2fwp-content%2fodgallery%2f2016%2f04%2f29707_Honda_navi_022.JPG&ehk=RM7P9AxIdRuIUu%2fqDABfoZBIanBUPu4KmYCjwld5EeI%3d&risl=&pid=ImgRaw&r=0",
            "https://1.bp.blogspot.com/-Oa4Kw9XzIL8/WPoo4LLWD0I/AAAAAAAAEKA/sBPa-EfbTvoJTyp-w6Dy94kNMFfEQbgtQCLcB/s1600/navi_f3q_right.jpg",
            "https://www.carblogindia.com/wp-content/uploads/2017/01/honda-navi-chrome-new-variant.jpg",
            "https://th.bing.com/th/id/R.e3c8d67f7bf36e065661c378fa14d168?rik=n4T3PhJLPahacA&riu=http%3a%2f%2fdata1.ibtimes.co.in%2fen%2ffull%2f621671%2fhonda-navi-makes-it-nepal.jpg&ehk=2RJ8%2fsdco2%2fABRYAsEp%2fujDeXchgN2deL57TI%2fkNxys%3d&risl=&pid=ImgRaw&r=0",
            "https://www.motoroids.com/wp-content/uploads/2016/04/New-Honda-Navi-Review-20.jpg"
        ]
    },
    {
        title:"BAJAJ",
        subTitle:"PULSAR 135 LS",
        daily:"₹459/Daily(24 hrs)",
        weekly:"₹1849/Weekly(Mon-Fri)",
        monthly:"₹4949/Monthly(30 days)",
        info:"The Bajaj Pulsar 135LS is the entry level model in the Pulsar range, which caters to customers looking for a commuter bike with a sporty character. The Pulsar range of motorcycles is a money spinner for Bajaj in India. It was the first Pulsar to feature a four valve head and had power ratings very close to its sibling the Pulsar 150. The motorcycle gets a 135cc, single cylinder air-cooled engine four valve engine that produces 13.56bhp and 11.4Nm of torque. Paired with a 5-speed gearbox, the 135cc unit allows the motorcycle to hit a top speed of 112kmph. It gets telescopic front suspension with anti-friction bush and five way adjustable nitrox shock absorbers at the rear",
        specification:[
            "Engine Capacity:135 cc",
            "Mileage:50.5 kmpl",
            "Kerb Weight:122 kg",
            "Fuel Tank Capacity:8 litres",
            "Seat Height:800 mm"
        ],
        img:[
            "https://casacamejo.com.mx/wp-content/uploads/2020/06/1-41.jpg",
            "https://th.bing.com/th/id/R.b1455d0d33c8687b4d37d500f124b9bd?rik=8MDooy80plXaPA&riu=http%3a%2f%2fstat.overdrive.in%2fwp-content%2fodgallery%2f2015%2f08%2f26698_3.jpg&ehk=aEw3IDrl9QGxkYnHdA3s2ae2Iurx%2b4CvCKMo7EsycEA%3d&risl=&pid=ImgRaw&r=0",
            "https://www.drivespark.com/img/2012/12/21-1356070545-pulsar-200ns.jpg",
            "https://th.bing.com/th/id/R.3280dd21f15694f316ebffc6ecec5362?rik=B%2fSiF98bkcoMsw&riu=http%3a%2f%2fim.rediff.com%2fgetahead%2f2012%2fjul%2f20bikes5.jpg&ehk=Y4zTd0t01DS%2buApSlbRPqE4D%2fjWyaWGhHtAtJ32AQDs%3d&risl=&pid=ImgRaw&r=0",
            "https://autoportal.com/img/models/87/a/plsr-135-color-laser-black-3.jpg"
        ]
    },
    {
        title:"BAJAJ",
        subTitle:"AVENGER 220 CRUISE",
        daily:"₹679/Daily(24 hrs)",
        weekly:"₹2799/Weekly(Mon-Fri)",
        monthly:"₹9649/Monthly(30 days)",
        info:"Bajaj Avenger Cruise 220 is a cruiser bike available at a starting price of Rs. 1,39,002 in India. It is available in only 1 variant and 2 colours. The Bajaj Avenger Cruise 220 is powered by 220cc BS6 engine which develops a power of 18.4 bhp and a torque of 17.55 Nm. With front disc and rear drum brakes, Bajaj Avenger Cruise 220 comes up with anti-locking braking system. This Avenger Cruise 220 bike weighs 163 kg and has a fuel tank capacity of 13 liters.Bajaj Auto has updated its flagship cruiser motorcycle, the Avenger Cruise 220 to comply with the newest emission norms. The BS6 upgrade on the Avenger Cruise 220 is limited to mechanical upgrades.",
        specification:[
            "Engine Capacity:220 cc",
            "Mileage:40 kmpl",
            "Kerb Weight:163 kg",
            "Fuel Tank Capacity:13 litres",
            "Seat Height:737 mm"
        ],
        img:[
            "https://i2.wp.com/www.iamabiker.com/wp-content/uploads/2018/04/Bajaj-Avenger-Cruise-220-HD-wallpapers-4.jpg?fit=2000%2C1125",
            "https://2.bp.blogspot.com/-qt2y5r7RN6A/V85pBAajdNI/AAAAAAAANdc/4y0Fw9oqqw44w-_tPukR5MvX5oOg5zh4wCLcB/s1600/Bajaj%2BAvenger%2Be.jpg",
            "https://www.rushlane.com/wp-content/uploads/2020/06/bajaj-avenger-220-cruise-bs6-price-hiked-by-rs-2500.jpg",
            "https://wallpapercave.com/wp/wp6977577.jpg",
            "https://media.zigcdn.com/media/content/2012/Dec/top-5-performance-bikes-bajaj-avenger-220-28122012-m4_560x420.jpg"
        ]
    },
    {
        title:"BAJAJ",
        subTitle:"AVENGER 220 STREET",
        daily:"₹679/Daily(24 hrs)",
        weekly:"₹2799/Weekly(Mon-Fri)",
        monthly:"₹9649/Monthly(30 days)",
        info:"The Avenger Street 220 has gotten an all-black treatment. While most of it is dipped in matt black, there are contrasting silver bits like the heat shield on the exhaust, wheel rim tape and a few side panels. The fuel tank may look similar to the one in the old model, but the new Avenger logo and the golden and red decals make the tank area look quite stylish. Bajaj has equipped the Avenger Street 220 with rubber bellows on the front suspension forks to complete the full black look of the motorcycle. Braking consists of a drum at the rear, but the front disc now has the option of single-channel ABS, an option worth a little less than Rs 7000 over the non-ABS Avenger.",
        specification:[
            "Engine Capacity:220 cc",
            "Mileage:40 kmpl",
            "Kerb Weight:150 kg",
            "Fuel Tank Capacity:14 litres",
            "Seat Height:725 mm"
        ],
        img:[
            "https://static.autox.com/uploads/2019/08/Bajaj-Avenger-Street-220-Image-6-.jpg",
            "https://1.bp.blogspot.com/-tkIGVCuXLuY/XSCKmYEuXkI/AAAAAAAAXb4/DsIi1l6SePk1XGARjwvBrlyON-erbqR5gCLcBGAs/s1600/bajaj%2Bavenger%2B220%2Bstreet%2Bwallpaper%2Bdefwwrdgb.jpg",
            "https://fastmb.ru/uploads/posts/2017-08/1503667131_indiyskiy-chopper-bajaj-avenger-street-220.jpg",
            "https://bajajrussia.ru/upload/iblock/1d5/1d52a7ca8b8d29cf7258a4900834c5d0.jpg",
            "https://image3.mouthshut.com/images/ImagesR/2016/10/Bajaj-Avenger-Street-220-925787060-8772344-1.jpg"
        ]
    },
    {
        title:"BAJAJ",
        subTitle:"PULSAR NS 220",
        daily:"₹829/Daily(24 hrs)",
        weekly:"₹3349/Weekly(Mon-Fri)",
        monthly:"₹9399/Monthly(30 days)",
        info:"It is powered by a 220cc, single-cylinder DTS-i engine that is BS6-compliant and fuel-injected. The motor delivers 21bhp of power and 19Nm torque and comes mated to a five-speed gearbox. Standard features on the model includes a telescopic front and a five-step adjustable, nitrox rear suspension, front and rear disc brakes and 120-section rear tyre. The Pulsar 220F has now been upgraded with a single-channel ABS system, to comply with the upcoming norms. Other features giving this bike a sporty intent are the split seats and rear grab rails, LED tail lights and clip-on handle bars.",
        specification:[
            "Engine Capacity:220 cc",
            "Mileage:38 kmpl",
            "Kerb Weight:150 kg",
            "Fuel Tank Capacity:15 litres",
            "Seat Height:795 mm"
        ],
        img:[
            "https://picstatio.com/download/1024x768/o320qg/2017-Bajaj-Pulsar-NS200-bike.jpg",
            "https://wallpapercave.com/wp/wp2429110.jpg",
            "https://1.bp.blogspot.com/-6CLlOKcvNHc/UdZ_4PouaJI/AAAAAAAAW2g/RYBcFheshao/s1280/Bajaj+Pulsar+200+NS+Wallpapers+%25288%2529.jpg",
            "https://wallpapercave.com/wp/wp2429056.jpg",
            "https://th.bing.com/th/id/R.6bc7634553c7d3800224ae1783664f88?rik=kMG9ozHW1XhTvA&riu=http%3a%2f%2fforum.maxabout.com%2fuploads%2fdefault%2foriginal%2f2X%2f6%2f672ad867b1618ca191093d1538655e7924d4a87a.png&ehk=5pJxJGZBfxKS5kRTaN3f7wyqzQuf09MXOt%2fQRFa1mO8%3d&risl=&pid=ImgRaw&r=0"
        ]
    },
    {
        title:"ROYAL ENFIELD",
        subTitle:"350 THUNDERBIRD",
        daily:"₹1039/Daily(24 hrs)",
        weekly:"₹4199/Weekly(Mon-Fri)",
        monthly:"₹12549/Monthly(30 days)",
        info:"It is powered by a 220cc, single-cylinder DTS-i engine that is BS6-compliant and fuel-injected. The motor delivers 21bhp of power and 19Nm torque and comes mated to a five-speed gearbox. Standard features on the model includes a telescopic front and a five-step adjustable, nitrox rear suspension, front and rear disc brakes and 120-section rear tyre. The Pulsar 220F has now been upgraded with a single-channel ABS system, to comply with the upcoming norms. Other features giving this bike a sporty intent are the split seats and rear grab rails, LED tail lights and clip-on handle bars.",
        specification:[
            "Engine Capacity:346 cc",
            "Mileage:35 kmpl",
            "Kerb Weight:192 kg",
            "Fuel Tank Capacity:20 litres",
            "Seat Height:775 mm"
        ],
        img:[
            "https://i2.wp.com/www.iamabiker.com/wp-content/uploads/2018/04/Royal-Enfield-Thunderbird-350X-HD-wallpapers-5.jpg",
            "https://cdn.pricesofindia.com/src/wallpapers/royal-enfield/royal-enfield-thunderbird/thunderbird-350-wallpaper-8.jpg",
            "https://wallpapercave.com/wp/wp3095976.jpg",
            "https://wallpapercave.com/wp/wp3096007.jpg",
            "https://www.team-bhp.com/forum/attachments/motorbikes/1250793d1402980371-my-foray-into-biking-world-royal-enfield-thunderbird-500-edit-charger-diy-too-displaymodelretb500stone.jpg"
        ]
    },
    {
        title:"ROYAL ENFIELD",
        subTitle:"350 CLASSIC",
        daily:"₹1049/Daily(24 hrs)",
        weekly:"₹4249/Weekly(Mon-Fri)",
        monthly:"₹12549/Monthly(30 days)",
        info:"Royal Enfield Classic 350 is a cruiser bike available at a starting price of Rs. 1,90,205 in India. It is available in 6 variants and 15 colours with top variant price starting from Rs. 2,21,158. The Royal Enfield Classic 350 is powered by 349cc BS6 engine which develops a power of 20.2 bhp and a torque of 27 Nm. With both front and rear disc brakes, Royal Enfield Classic 350 comes up with anti-locking braking system. This Classic 350 bike weighs 195 kg and has a fuel tank capacity of 13 liters.",
        specification:[
            "Engine Capacity:349 cc",
            "Mileage:34.5 kmpl",
            "Kerb Weight:195 kg",
            "Fuel Tank Capacity:13 litres",
            "Seat Height:805 mm"
        ],
        img:[
            "https://www.iamabiker.com/wp-content/uploads/2020/09/Royal-Enfield-Classic-350-BS6-Stealth-Black-HD-wallpapers-7.jpg",
            "https://www.wallpapersin4k.org/wp-content/uploads/2017/04/Royal-Enfield-Classic-350-Black-HD-Wallpaper-20.jpg",
            "https://wallpapercave.com/wp/wp5247078.jpg",
            "https://wallpapercave.com/wp/wp2432660.jpg",
            "https://i.pinimg.com/originals/cd/dd/03/cddd03e15877e05c439c3474578e0a70.jpg"
        ]
    },
    {
        title:"HONDA",
        subTitle:"CBR 150",
        daily:"₹1109/Daily(24 hrs)",
        weekly:"₹4499/Weekly(Mon-Fri)",
        monthly:"₹14899/Monthly(30 days)",
        info:"Royal Enfield Classic 350 is a cruiser bike available at a starting price of Rs. 1,90,205 in India. It is available in 6 variants and 15 colours with top variant price starting from Rs. 2,21,158. The Royal Enfield Classic 350 is powered by 349cc BS6 engine which develops a power of 20.2 bhp and a torque of 27 Nm. With both front and rear disc brakes, Royal Enfield Classic 350 comes up with anti-locking braking system. This Classic 350 bike weighs 195 kg and has a fuel tank capacity of 13 liters.",
        specification:[
            "Engine Capacity:149 cc",
            "Mileage:37 kmpl",
            "Kerb Weight:138 kg",
            "Fuel Tank Capacity:13 litres",
            "Seat Height:1120 mm"
        ],
        img:[
            "https://i0.wp.com/www.iamabiker.com/wp-content/uploads/2012/04/cbr-150r-india-wallpapers-09.jpg",
            "https://th.bing.com/th/id/R.b51afc32ec3dd76d71b3a55d403af739?rik=hQFy1rspia3dog&riu=http%3a%2f%2fwww.9carthai.com%2fwp-content%2fuploads%2f2019%2f04%2fHONDA-CBR150R-2019.jpg&ehk=Xd%2fJIXOXOSKpYHgqWO5fixn%2bwzyhbuIQdO3u%2fGret2w%3d&risl=&pid=ImgRaw&r=0&sres=1&sresct=1",
            "https://th.bing.com/th/id/R.e435aea77b6bb1056e2762e78f69b7e7?rik=wofQ4NnG1Dd6nw&riu=http%3a%2f%2f4.bp.blogspot.com%2f-VKEUsCNZKAc%2fUKow_MVGh3I%2fAAAAAAAAAGA%2f8gHQyZUwvzY%2fs1600%2fBlack-Honda-CBR-150R-Motorcycles%2bwaystoworld.com%2bjpg.jpg&ehk=yEpFGh3jq7swguHFBKhE74qZdGNGRvLqhehRcfhjsAk%3d&risl=&pid=ImgRaw&r=0",
            "https://i.pinimg.com/736x/03/7a/ac/037aac999b8c9253a2d759f9baddc944--bike-wallpaper-wallpaper-backgrounds.jpg",
            "https://pakistani.pk/uploads/reviews/photos/original/4b/f8/06/Honda-CBR150R-Test-Ride-Review-73-1435202536.jpg"
        ]
    },
    {
        title:"ROYAL ENFIELD",
        subTitle:"CONTINENTAL GT 500",
        daily:"₹1249/Daily(24 hrs)",
        weekly:"₹5099/Weekly(Mon-Fri)",
        monthly:"₹17099/Monthly(30 days)",
        info:"Royal Enfield Continental GT 650 is a cafe racer bike available at a starting price of Rs. 3,04,974 in India. It is available in 3 variants and 5 colours with top variant price starting from Rs. 3,30,793. The Royal Enfield Continental GT 650 is powered by 648cc BS6 engine which develops a power of 47 bhp and a torque of 52 Nm. With both front and rear disc brakes, Royal Enfield Continental GT 650 comes up with anti-locking braking system. This Continental GT 650 bike weighs 198 kg and has a fuel tank capacity of 12.5 liters.",
        specification:[
            "Engine Capacity:648 cc",
            "Mileage:25 kmpl",
            "Kerb Weight:198 kg",
            "Fuel Tank Capacity:12.5 litres",
            "Seat Height:793 mm"
        ],
        img:[
            "https://i.pinimg.com/originals/58/9b/07/589b074c0247d7555a1ef2fe08e60dcc.jpg",
            "https://www.motorkari.cz/upload/images/clanky/2014-06/28678/1.jpg",
            "https://bikereview.com.au/wp-content/uploads/2019/05/2019-Royal-Enfield-Continental-GT-650-Bike-Review-MJK9046.jpg",
            "https://assets.shannons.com.au/images/LA9U6TXKFZQ12F6D/E963GK6VQDMRBP20/1078x809x3/0h9snr615ef16lj2-yxshbwqp477mrwhw.jpg",
            "https://s1.cdn.autoevolution.com/images/news/gallery/custom-royal-enfield-continental-gt-morphed-at-the-hands-of-motomax_8.jpg"
        ]
    },
    {
        title:"ROYAL ENFIELD",
        subTitle:"HIMALAYAN 411 CC",
        daily:"₹1249/Daily(24 hrs)",
        weekly:"₹5049/Weekly(Mon-Fri)",
        monthly:"₹14749/Monthly(30 days)",
        info:"Royal Enfield Himalayan is a adventure bike available at a starting price of Rs. 2,14,714 in India. It is available in 3 variants and 9 colours with top variant price starting from Rs. 2,22,350. The Royal Enfield Himalayan is powered by 411cc BS6 engine which develops a power of 24.3 bhp and a torque of 32 Nm. With both front and rear disc brakes, Royal Enfield Himalayan comes up with anti-locking braking system. This Himalayan bike weighs 199 kg and has a fuel tank capacity of 15 liters.",
        specification:[
            "Engine Capacity:411 cc",
            "Mileage:30 kmpl",
            "Kerb Weight:199 kg",
            "Fuel Tank Capacity:15 litres",
            "Seat Height:800 mm"
        ],
        img:[
            "https://www.wallpapertip.com/wmimgs/238-2383841_2019-royal-enfield-himalayan-411-efi-abs-in.jpg",
            "https://www.royalenfield.com/content/dam/royal-enfield/france/motorcycles/himalayan/gallery/gallery-8.png",
            "https://www.royalenfield.com/content/dam/royal-enfield/philippines/motorcycles/himalayan/gallery/new/gallery-41.jpg",
            "https://i.pinimg.com/originals/ec/bb/2c/ecbb2cf74a0b080fb653c49c3ae09bd8.jpg",
            "https://www.coolcovers.co.uk/wp-content/uploads/2018/04/RYERSTD01-bikeIMG_20200611_111946-scaled.jpg"
        ]
    },
    {
        title:"KTM",
        subTitle:"DUKE 250",
        daily:"₹1389/Daily(24 hrs)",
        weekly:"₹5649/Weekly(Mon-Fri)",
        monthly:"₹17599/Monthly(30 days)",
        info:"KTM 250 Duke is a street bike available at a starting price of Rs. 2,33,567 in India. It is available in only 1 variant and 2 colours. The KTM 250 Duke is powered by 248.76cc BS6 engine which develops a power of 29.6 bhp and a torque of 24 Nm. With both front and rear disc brakes, KTM 250 Duke comes up with anti-locking braking system. This 250 Duke bike weighs 170 kg and has a fuel tank capacity of 13.4 liters.",
        specification:[
            "Engine Capacity:248.76 cc",
            "Mileage:30 kmpl",
            "Kerb Weight:170 kg",
            "Fuel Tank Capacity:13.4 litres",
            "Seat Height:822 mm"
        ],
        img:[
            "https://wallpapercave.com/wp/wp2474622.jpg",
            "https://wallpapercave.com/wp/wp2474631.jpg",
            "https://i.pinimg.com/originals/78/40/f2/7840f233f7e013beb9fa350c8d126000.jpg",
            "https://wallpapercave.com/wp/wp2474657.jpg",
            "https://wallpapercave.com/wp/wp2474732.jpg"
        ]
    },
];

export default data;